import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRankingHouseFamily } from './interface/IRefRankingHouseFamily';

@Entity('ref_ranking_house_family')
export class RefRankingHouseFamily extends BaseEntity implements IRefRankingHouseFamily{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
